const imageCache = new Map();
export const getImage = async (url: string): Promise<CanvasImageSource> => {
  return new Promise((resolve) => {
    if (imageCache.has(url)) {
      resolve(imageCache.get(url));
    } else {
      const img = new Image();
      img.onload = () => {
        // use image directly for SVG, the image is crisper vs a canvas
        if (url.endsWith('.svg')) {
          return resolve(img);
        } else {
          const canvas = new OffscreenCanvas(img.width, img.height);
          const context = canvas.getContext('2d');
          context?.drawImage(img, 0, 0);
          imageCache.set(url, canvas);
          resolve(canvas);
        }
      };

      img.src = url;
    }
  });
};

export const clearCache = () => {
  imageCache.clear();
};
